"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const traps_helpers_1 = require("./traps_helpers");
/* MAKE TRAPS */
function makeTraps(object, callback) {
    return new traps_helpers_1.default(object, callback).traps;
}
/* EXPORT */
exports.default = makeTraps;
